import mterial_tipo_model from './material_tipo_model';
import materia_prima_familia_model from './materia_prima_familia_model';
import moneda_model from './moneda_model';
import unidad_medida_model from './unidad_medida_model';

export default {
  Activo: true,
  Alto: null,
  Ancho: null,
  Codigo: null,
  CodigoAdicional: null,
  CodigoColor: null,
  CodigoEquivalente: null,
  CodigoFamilia: null,
  CodigoMaterialTipo: null,
  CodigoMoneda: null,
  CodigoProveedor: null,
  CodigoUnidadMedida: null,
  CodigoUnidadMedidaSecundaria: null,
  CodigoUsuarioActualizacion: null,
  CodigoUsuarioCreacion: null,
  Costo: null,
  Densidad: null,
  DescripcionComercial: null,
  DescripcionInterna: null,
  Diametro: null,
  Espesor: null,
  Exact: null,
  FactorConversion: null,
  FactorConversion23: null,
  FechaActualizacion: null,
  FechaCreacion: null,
  Gramaje: null,
  Largo: null,
  Rendimiento: null,
  CodigoCategoriaIVA: null,
  MaterialTipo: { ...mterial_tipo_model },
  MateriaPrimaFamilia: { ...materia_prima_familia_model },
  Moneda: { ...moneda_model },
  Tipo: null,
  TiempoEntrega: null,
  UnidadMedida: { ...unidad_medida_model },
  UnidadMedidaSecundaria: { ...unidad_medida_model },
};
